module.exports = __webpack_public_path__ + "static/img/wayfinding-sign-weathering-steel.35728ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/what-we-do/wayfinding-sign-weathering-steel.jpg
// module id = 150
// module chunks = 0